import React, { useState, useEffect } from 'react';
import HomeTopBar from './HomeTopBar';
import ProductMarketShareSavingsChart from '../charts/ProductMarketShare/ProductMarketShareSavingsChart';
import ProductMarketShareChequeChart from '../charts/ProductMarketShare/ProductMarketShareChequeChart';
import ProductMarketShareCreditCardChart from '../charts/ProductMarketShare/ProductMarketShareCreditCardChart';
import ProductMarketShareHomeLoanChart from '../charts/ProductMarketShare/ProductMarketShareHomeLoanChart';
import ProductMarketShareVehicleFinanceChart from '../charts/ProductMarketShare/ProductMarketShareVehicleFinanceChart';
import axios from 'axios';
import { provinces, local_market, province_market_map, segments } from '../constants';
import ProductMarketSharePPTX from '../powerpoint/ProductMarketSharePPTX';

const ProductMarketShare = ({ heading, savings, cheque, credit_card, home_loan, vaf }) => {
  const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedLocalMarket, setSelectedLocalMarket] = useState('');
  const [selectedSegment, setSelectedSegment] = useState('');
  const [localMarkets, setLocalMarkets] = useState([]);
  const [savingsData, setSavingsData] = useState([]);
  const [chequeData, setChequeData] = useState([]);
  const [creditCardData, setCreditCardData] = useState([]);
  const [homeLoanData, setHomeLoanData] = useState([]);
  const [vehicleFinanceData, setVehicleFinanceData] = useState([]);

  const handleProvinceChange = (e) => {
    const selectedProvince = e.target.value;
    setSelectedProvince(selectedProvince);

    if (selectedProvince && province_market_map[selectedProvince]) {
      setLocalMarkets(province_market_map[selectedProvince].local_markets);
    } else {
      setLocalMarkets([]);
    }
    setSelectedLocalMarket('');
  };

  const getProvinceValue = () => (selectedProvince ? provinces[selectedProvince] : '');
  const getLocalMarketValue = () => (selectedLocalMarket ? local_market[selectedLocalMarket] : '');
  const getSegmentValue = () => (selectedSegment ? segments[selectedSegment] : '');

  const fetchProductMarketShareData = async (preferenceType, setData) => {
    try {
      const provinceValue = getProvinceValue();
      const localMarketValue = getLocalMarketValue();

      const response = await axios.get(`https://outlook.plus94research.co.za/api/product_market_share/${preferenceType}/`, {
        params: {
          province: provinceValue,
          local_market: localMarketValue,
          segment: selectedSegment  
        },
      });
      setData(response.data.chart_data);
    } catch (error) {
      console.error(`Error fetching data for ${preferenceType}:`, error);
      setData([]);
    }
  };

  useEffect(() => {
    fetchProductMarketShareData('savings', setSavingsData);
  }, [selectedProvince, selectedLocalMarket, selectedSegment]);

  useEffect(() => {
    fetchProductMarketShareData('cheque', setChequeData);
  }, [selectedProvince, selectedLocalMarket, selectedSegment]);

  useEffect(() => {
    fetchProductMarketShareData('credit_card', setCreditCardData);
  }, [selectedProvince, selectedLocalMarket, selectedSegment]);

  useEffect(() => {
    fetchProductMarketShareData('home_loan', setHomeLoanData);
  }, [selectedProvince, selectedLocalMarket, selectedSegment]);

  useEffect(() => {
    fetchProductMarketShareData('vehicle_finance', setVehicleFinanceData);
  }, [selectedProvince, selectedLocalMarket, selectedSegment]);

  return (
    <div className='home'>
      <HomeTopBar />
      <div className='three-charts-heading-div'>
        <h2 className='heading'>{heading}</h2>
      </div>

      <div className='filter'>
        <label htmlFor="province-select">Province: </label>
        <select
          id="province-select"
          value={selectedProvince}
          onChange={handleProvinceChange}
        >
          <option value="">All</option>
          {Object.keys(provinces).map((province) => (
            <option key={province} value={province}>
              {province}
            </option>
          ))}
        </select>

        <label htmlFor="local-market-select">Local Market: </label>
        <select
          id="local-market-select"
          value={selectedLocalMarket}
          onChange={(e) => setSelectedLocalMarket(e.target.value)}
          disabled={!selectedProvince || localMarkets.length === 0}
        >
          <option value="">All</option>
          {localMarkets.map((market, index) => (
            <option key={index} value={market}>
              {market}
            </option>
          ))}
        </select>

        <label htmlFor="segment-select">Segments: </label>
        <select
          id="segment-select"
          value={selectedSegment}
          onChange={(e) => setSelectedSegment(e.target.value)}
        >
          <option value="">All</option>
          {Object.keys(segments).map((segment) => (
            <option key={segment} value={segment}>
              {segment}
            </option>
          ))}
        </select>
      </div>

       <div>
        <ProductMarketSharePPTX
          selectedProvince={selectedProvince}
          selectedLocalMarket={selectedLocalMarket}
          savingsData={savingsData}
          chequeData={chequeData}
          creditCardData={creditCardData}
          homeLoanData={homeLoanData}
          vehicleFinanceData={vehicleFinanceData}
        />
      </div> 

      <div className='five-charts-container'>
        <div className='check-and-savings'>
          <div className='savings'>
            <h2 className='five-charts-heading'>{savings}</h2>
            <ProductMarketShareSavingsChart data={savingsData} />
          </div>
          <div className='cheque'>
            <h2 className='five-charts-heading'>{cheque}</h2>
            <ProductMarketShareChequeChart data={chequeData} />
          </div>
        </div>

        <div className='credit-card-and-home-loan'>
          <div className='credit-card'>
            <h2 className='five-charts-heading'>{credit_card}</h2>
            <ProductMarketShareCreditCardChart data={creditCardData} />
          </div>
          <div className='home-loan'>
            <h2 className='five-charts-heading'>{home_loan}</h2>
            <ProductMarketShareHomeLoanChart data={homeLoanData} />
          </div>
        </div>

        <div className='vaf-div'>
          <div className='vaf'>
            <h2 className='five-charts-heading'>{vaf}</h2>
            <ProductMarketShareVehicleFinanceChart data={vehicleFinanceData} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductMarketShare;

